<template>
    <v-container>
        <h1 class="titulo mb-3">Importação de propostas CSV</h1>
        <v-card class="card">
            <v-card-text>
                <v-form ref="form" @submit.prevent="importar">
                    <v-row>
                        <p class="col-12 text-center">Faça o upload de um arquivo em formato .CSV para importar propostas ao sistema e emitir contratos via AC</p>
                    </v-row>
                    <v-row>
                        <v-col class="col-6 offset-3">
                            <v-file-input
                                    label="Upload de propostas:"
                                    accept=".csv"
                                    dense
                                    outlined
                                    v-model="file"
                            ></v-file-input>
                        </v-col>
                    </v-row>
                    <v-row class="justify-space-between">
                        <v-col style="vertical-align: middle;">
                            <v-btn @click="download" class="transition" color="primary" rounded>
                                <v-icon small style="margin-right: 8px"> cloud_download </v-icon>
                                Modelo do arquivo
                            </v-btn>
                        </v-col>
                        <v-col cols="3" style="vertical-align: middle;">
                            <v-btn class="transition" color="secondary" rounded type="submit">
                                <v-icon small style="margin-right: 8px"> cloud_upload </v-icon>
                                Importar propostas
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
        <div v-if="log">
            <h1 class="col-12 text-center" style="margin-top:25px;">Veja abaixo o log da importação</h1>
            <v-card class="card">
                <v-card-text>
                    <span style="white-space: pre-line"> {{ log }} </span>
                </v-card-text>
            </v-card>
        </div>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { MB } from '@/plugins/constants'

  export default {
    name: 'ImportaProposta',
    data: () => ({
      file: null,
      log: '',
      url: null
    }),
    watch: {
      file (val) {
        if (val && val.size > 60 * MB) {
          notification('error', 'O arquivo enviado possui mais de 60MB, por favor, escolha um arquivo menor.')
          this.file = null
        }
      }
    },
    mounted () {
      this.$http.get('/link').then(res => {
        if (res.data) {
          this.url = res.data
        }
      })
    },
    methods: {
      importar () {
        let formData = new FormData()

        if (this.file) {
          formData.append('file', this.file)

          this.$http.post('/painel/importa/proposta', formData)
            .then((res) => {
              if (res.data) {
                this.log = res.data.saida
                if (!res.data.ok) {
                  notification('error', res.data.msg_Erro)
                }
              }
            })
            .catch(e => {
              this.log = e
              notification('error', 'Não foi possível importar as propostas, veja abaixo o log de importação.')
            })
        }
      },
      download () {
        window.open(`${this.url}exemplo`, '_blank')
      }
    }
  }

</script>

<style scoped>

</style>
